import React, { FC } from 'react';

import WebdoorControls from '../WebdoorControls';
import WebdoorInfo from './WebdoorInfo';

import { IWebdoorInfoList } from './interfaces';

import './styles.scss';

// webdoor info
const WebdoorInfoList: FC<IWebdoorInfoList> = ({
  current,
  items,
  factoryLink,
  setCurrent
}) => {
  // render
  return (
    <div
      className="webdoor-info-list">
      <div className="webdoor-info-list--container">
        {items && items.map((item: any, index: number) =>
          <WebdoorInfo
            active={current === index}
            item={item}
            factoryLink={factoryLink}
            key={index} />)}
      </div>

      <WebdoorControls
        items={items}
        current={current}
        setCurrent={setCurrent} />
    </div>
  );
};

export default WebdoorInfoList;